const normalizeUrl = (input: string): URL | null => {
  try {
    return new URL(input, window.location.origin);
  } catch {
    return null;
  }
};

const shouldAppendDebugParams = (): boolean => {
  const debugEnabled =
    typeof __ENABLE_DEV_DEBUG_QUERY__ !== 'undefined' && __ENABLE_DEV_DEBUG_QUERY__ === true;
  const hasDebugKey = typeof __DEV_DEBUG_KEY__ !== 'undefined' && Boolean(__DEV_DEBUG_KEY__);
  const hasDebugOrigin = typeof __DEV_DEBUG_ORIGIN__ !== 'undefined' && Boolean(__DEV_DEBUG_ORIGIN__);

  if (typeof window === 'undefined' || !debugEnabled || !hasDebugKey || !hasDebugOrigin) {
    return false;
  }

  return window.location.origin === __DEV_DEBUG_ORIGIN__;
};

export const buildRequestUrl = (input: string): string => {
  if (!shouldAppendDebugParams()) {
    return input;
  }

  const url = normalizeUrl(input);
  if (!url) {
    return input;
  }

  const debugDomain =
    typeof __DEV_DEBUG_DOMAIN__ !== 'undefined' && __DEV_DEBUG_DOMAIN__
      ? __DEV_DEBUG_DOMAIN__
      : 'IOLAS';

  url.searchParams.set('debugDomain', debugDomain);
  url.searchParams.set('debugKey', __DEV_DEBUG_KEY__);

  const finalUrl = url.toString();
  console.log(`[request-url][debug] ${finalUrl}`);

  return finalUrl;
};
